export default {

    setLoading(context, loading) {
        context.commit("setLoading", loading);
    },
}